<template>
  <el-dialog title="修改状态" :visible.sync="dialogVisible" @close="$emit('update:visible',false)" width="430px">
    <p>请在完成线下手动打款后，再点击“确定”对提现状态进行修改，避免状态出错。</p>
    <el-table class="mt20" :data="tableData" stripe border style="width: 100%">
      <el-table-column prop="user_name" label="提现账号" width="200">
        <template slot-scope="scope">
          {{scope.row.user_name}}
        </template>
      </el-table-column>
      <el-table-column prop="money_tax" label="扣税后金额">
        <template slot-scope="scope">
          ￥{{scope.row.money_tax}}
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="savePrograma" size="small">确 定</el-button>
    </span>    
  </el-dialog>  
</template>

<script>
import api from "@/api.js";
export default {
  name: "withdrawalStatus",
  props: ["visible","employee","whotype"],
  data() {
    return{
      dialogVisible: false,
      tableData: []
    }
  },    
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    },
    employee() {
      this.tableData[0] = this.employee;
    }
  },
  methods: {
    savePrograma() { 
      this.axios
          .post(api.companyadmin_withdraw_change_state, {withdraw_id: this.employee.id, who: this.whotype})
          .then(response => {
            if (response.data.code == 0) {
               this.$emit("refresh"); 
            }
          })
          .catch(response => {
          });
    }
  }
}
</script>